import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import {  Cookies } from 'react-cookie';
import ChangeFireHomeKind from './ChangeFireHomeKind';
import ChangeFireHomeBuildinglife from './ChangeFireHomeBuildinglife';
import ChangeFireHomeCostcons from './ChangeFireHomeCostcons';
import ChangeFireHomeCoverage from './ChangeFireHomeCoverage';
import ChangeFireHomeTypeofcons from './ChangeFireHomeTypeofcons';
import ChangePriceFireHome from './ChangePriceFireHome';
import ChangePriceFireWarehouse from "./ChangePriceFireWarehouse";
import ChangePriceFireIndustrial from "./ChangePriceFireIndustrial";
import ChangePriceFireNonIndustrial from "./ChangePriceFireNonIndustrial";



const styles = theme => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
    , paper: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },


});

class ChangeFireNonIndustrial extends Component {
    cookies=new Cookies();
    constructor(props) {
        super(props);
        this.state = {
            value:0,
        }}

    componentDidMount() {

    }
    handleChange= (event,newValue) => {
        this.setState({ value:newValue });
    }
    render() {
        const { classes } = this.props;
        const { value } = this.state;

        return (
            <div>
                <AppBar position="sticky"color="primary" >

                    <Tabs
                        style={{height:'60px',textAlign:'center'}}
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="secondary"
                        textColor={'#000000'}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >
                        {/*<Tab label="انواع ملک"  />*/}
                        {/*<Tab label="عمر بنا"  />*/}
                        {/*<Tab label="هزینه ساخت"  />*/}
                        {/*<Tab label="پوشش اضافی بیمه نامه "  />*/}
                        {/*<Tab label="نوع سازه"  />*/}
                        <Tab label="قیمت بیمه"  />
                    </Tabs>


                </AppBar>
                {/*{(value===0)?<ChangeFireHomeKind  props={this.props}/>:null}*/}
                {/*{(value===1)?<ChangeFireHomeBuildinglife  props={this.props}/>:null}*/}
                {/*{(value===2)?<ChangeFireHomeCostcons  props={this.props}/>:null}*/}
                {/*{(value===3)?<ChangeFireHomeCoverage  props={this.props}/>:null}*/}
                {/*{(value===4)?<ChangeFireHomeTypeofcons  props={this.props}/>:null}*/}
                {(value===0)?<ChangePriceFireNonIndustrial  props={this.props}/>:null}

            </div>
        );
    }
}

export default  withStyles(styles)(ChangeFireNonIndustrial);
